import { Typography } from "@mui/material";
import React from "react";

export const SubPageTitleWithUnderline = ({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">{title}</Typography>
        <div>{children}</div>
      </div>
      <hr
        style={{
          width: "100%",
          height: "2px",
          backgroundColor: "black",
          margin: "10px 0",
        }}
      />
    </>
  );
};
